<template>
  <div class="main update_trip_wrp">
    <div>
      <div>
        <div class="c-pointer">
          <a v-on:click.stop="updateTrip()">Update Segregation Plant Trip</a>
        </div>
      </div>

      <div class="shedule_date_data_paddi">
        <div class="shedule_date_data">
          <div class="shedule_date_inner">
            <h5>Schedule Date and Time</h5>
            <p>{{ details.scheduleTime ? details.scheduleTime : "--" }}</p>
          </div>

          <div class="shedule_date_inner">
            <h5>Trip Start Date and Time</h5>
            <p>
              {{ details.startTime ? details.startTime : "--" }}
            </p>
          </div>
          <div class="shedule_date_inner">
            <h5>Trip End Date and Time</h5>
            <p>{{ details.endTime ? details.endTime : "--" }}</p>
          </div>

          <div class="shedule_date_inner">
            <h5>Trip Start Point</h5>
            <p>
              {{
                details.dumpYardId[0].dumpYardName ? details.dumpYardId[0].dumpYardName : "--"
              }}
            </p>
          </div>

          <div class="shedule_date_inner">
            <h5>Trip End Point</h5>
            <p>
              {{ details.segregationId[0].plantName ? details.segregationId[0].plantName : "--" }}
            </p>
          </div>

          <!-- next -->

          <div class="shedule_date_inner">
            <h5>Driver</h5>
            <p>
              {{
                details.driverId[0].firstName +
                  " " +
                  details.driverId[0].lastName
              }}
            </p>
          </div>
          <div class="shedule_date_inner">
            <h5>Vehicle</h5>
            <p>{{ details.vehicleId[0].vNumber }}</p>
          </div>
          <div class="shedule_date_inner">
            <h5>Total Waste (KG)</h5>
            <p>
              {{
                details.totalWeight ? details.totalWeight : "--"
              }}
            </p>
          </div>
          <div class="shedule_date_inner">
            <h5>Status</h5>
            <p>{{ details.tripStatus }}</p>
          </div>
        </div>

        <!-- <div class="collection_division_details_ssec">
          <h3>Collection Division Details</h3>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import { transportPointTripService } from "../../../services";
import dateFormatter from "../../utilities/dateFormate";
export default {
  name: "viewPrimaryTrip",
  components: {
    Datepicker,
  },

  data() {
    return {
      loading: false,
      flash: false,
      flashType: null,
      details: {},
      _id: "",
    };
  },

  methods: {
    getTripInfo() {
      return transportPointTripService
        .getById(this.$route.params._id)
        .then((response) => {
          this.loading = false;
          this.details = response.data;
          this._id = this.details._id;
          // let scheduleTime = moment(this.details.scheduleTime).format("DD-MM-YYYY , HH:MM A");
          let scheduleTime = dateFormatter(this.details.scheduleTime);
          this.details["scheduleTime"] = scheduleTime;
          let tripStatuss = response.data.tripStatus;
          this.details["tripStatus"] =
            tripStatuss.charAt(0).toUpperCase() + tripStatuss.slice(1);
        })
        .catch((error) => {
          this.loading = false;
          console.error("tripDetails.getTripDetails-error:", error);
        });
    },

    updateTrip() {
      this.$router.push({
        name: "createTransportPointTrip",
        params: {
          _id: this._id,
        },
      });
    },
  },

  created() {
    const promises = [];
    this.loading = true;
    if (this.$route.params && this.$route.params._id && this.$route.params._id != '0') {
        promises.push(this.getTripInfo());
    }
    Promise.all(promises)
      .then(() => {
        this.loading = false;
        this.ready = true;
      })
      .catch(() => {
        this.loading = false;
      });
  },
};
</script>

<style>
.main {
  margin-left: 15px;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 90%;
  margin: 10px;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

.Bold {
  font-weight: bold;
}
.max-widht-80 {
  max-width: 80px;
}
.update_trip_wrp .c-pointer {
  text-align: right;
  padding-right: 15px;
}
.update_trip_wrp .c-pointer a {
  color: #0f6940;
  font-weight: 700;
  font-size: 18px;
  padding-top: 10px;
  display: inline-block;
  text-decoration: underline;
}
.update_trip_wrp table {
  width: 99%;
  margin: 0;
  margin-top: 20px;
}
.update_trip_wrp .Bold {
  font-weight: bold;
  background: #0f6940;
  color: #fff;
}
.update_trip_wrp table th,
.update_trip_wrp table td {
  border: 1px solid #b3b0b0;
  padding: 10px;
}

.shedule_date_data {
  background: #0f6940;
  padding: 10px;
  display: flex;
  margin-top: 10px;
  color: #fff;
  flex-wrap: wrap;
}
.shedule_date_inner {
  flex: 0 0 25%;
  margin-bottom: 5px;
}
.shedule_date_data_paddi {
  padding-right: 15px;
}
.shedule_date_inner p {
  font-size: 15px;
  font-weight: 600;
}
.shedule_date_inner h5 {
  margin-bottom: 5px;
  font-size: 14px;
  color: #0ce595;
}
.collection_division_details_ssec h3 {
  font-size: 20px;
  font-weight: 700;
}
.update_trip_wrp {
  height: calc(100vh - 150px);
  overflow: auto;
  overflow-x: hidden;
}

.update_trip_wrp::-webkit-scrollbar {
  width: 5px;
}

.update_trip_wrp::-webkit-scrollbar-thumb {
  background: #888;
}
</style>



// WEBPACK FOOTER //
// viewTransportPointTrip.vue?789ec5d8